module.exports = __webpack_public_path__ + "img/HQ-Z7100-V1-All.12c34089.jpg";